import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import PopupButton from '../../shared/PopupButton';
import { getTrendQuickRange } from 'utils/helpers';
import Timeline from './Timeline';
import styles from './TrendTimeline.styles';
import messages from './TrendTimeline.messages';
import { injectIntl } from 'react-intl';

export const timeToPercentage = (time, startMoment, endMoment) => {
  const percentage = 100 * moment(time).diff(startMoment, 'seconds') / endMoment.diff(startMoment, 'seconds');
  return percentage;
};
export const percentageToTime = (startMoment, endMoment) => {
  const duration = endMoment.diff(startMoment, 'seconds');
  return percentage => {
    return startMoment.clone().add((percentage / 100) * duration, 'seconds'); 
  };
};

const TrendTimeline = ({
  startTime,
  endTime,
  trends,
  currentTrendId,
  allTrendTypes,
  height,
  expand,
  onSelectTime,
  onSetExpand,
  onSetQuickRange = _.noop,
  intl: {
    formatMessage
  }
}) => {
  const startMoment = moment(startTime);
  const endMoment = moment(endTime);
  const items = _.chain(trends)
    .map(trend => ({
      start: timeToPercentage(trend.from, startMoment, endMoment),
      end: timeToPercentage(trend.to, startMoment, endMoment),
      trend,
      highlighted: currentTrendId === trend.id
    }))
    .filter(trend => trend.end > 0 && trend.start < 100)
    .value();
  return (
    <div style={styles.root}>
      <PopupButton
        size='mini'
        color='blue'
        popupText={expand
          ? formatMessage(messages['collapseButton.popupText'])
          : formatMessage(messages['expandButton.popupText'])}
        icon={expand
          ? 'chevron up'
          : 'chevron down'}
        style={styles.expandButton}
        onClick={() => onSetExpand(!expand)} />
      <Timeline
        items={items}
        allTrendTypes={allTrendTypes}
        height={height}
        percentageToTime={percentageToTime(startMoment, endMoment)}
        onSelectTime={onSelectTime}
        onClickTrend={trend => {
          onSelectTime(trend.to);
          onSetQuickRange(getTrendQuickRange(trend));
        }} />
    </div>
  );
};

TrendTimeline.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  trends: PropTypes.array.isRequired,
  currentTrendId: PropTypes.string,
  onSelectTime: PropTypes.func,
  onSetQuickRange: PropTypes.func
};

TrendTimeline.displayName = 'TrendTimeline';

export default injectIntl(TrendTimeline);